import {
  AGraphFilterCriteria,
  PortfolioAnalysisDefinition,
  PortfolioAnalysisReport,
  PortfolioReportEntity,
  ReportSummaryDefinition,
} from '../AWPortfolioManagement';
import { awPortfolioAnalysisReportApiClient } from './Base';
import {
  AGraphPortfolioAnalyticsGenericResponse,
  GenerateReportByTemplateResponse,
  LongRunningOperationsResponse,
} from './types';

function generateReport(
  request: {
    entityTag?: string;
    portfolioAnalysisDefinition?: PortfolioAnalysisDefinition;
    portfolioAnalysisFilter?: {
      accountsFilter: AGraphFilterCriteria;
      positionsFilter: AGraphFilterCriteria;
    };
    portfolioReportEntity?: PortfolioReportEntity;
    reportName?: string;
    reportSummaryDefinition?: ReportSummaryDefinition;
    viewAsUser?: string;
  },
  signal?: AbortSignal
) {
  const path = `portfolioAnalysisReport:generate`;
  return awPortfolioAnalysisReportApiClient.post<AGraphPortfolioAnalyticsGenericResponse>(path, request, { signal });
}

function getReportStatus(operationId: string, signal?: AbortSignal) {
  const path = `longRunningOperations/${operationId}`;
  return awPortfolioAnalysisReportApiClient.get<LongRunningOperationsResponse>(path, { signal });
}

function getReport({ reportId, userId, pkg }: { reportId: string; pkg: string; userId: string }, signal?: AbortSignal) {
  const path = `portfolioAnalysisReport/${reportId}`;
  return awPortfolioAnalysisReportApiClient.get<PortfolioAnalysisReport>(path, {
    params: {
      userId,
      pkg,
    },
    signal,
  });
}

function generateReportByTemplate(
  request: {
    pkg: string;
    entity_tag: string;
    report_template_name: string;
    as_of_dates: string[];
    template_parameters: Record<string, { stringValue?: string; double_value?: number; bool_value?: boolean }>;
    filters: unknown[];
    viewAsUser?: string;
  },
  signal?: AbortSignal
) {
  const path = `portfolioAnalysisReports:generateReportByTemplate`;
  return awPortfolioAnalysisReportApiClient.post<GenerateReportByTemplateResponse>(path, request, { signal });
}

export const awPortfolioAnalysisReportAPI = {
  generateReport,
  generateReportByTemplate,
  getReport,
  getReportStatus,
};
